import { TFunction } from "i18next";

import { LocationActivityLogType } from "../../../models/LocationActivityLog";
import { translateCsvValues } from "../../../utils/csvUtils";

/* Translate raw activity type keys (e.g. "new_review") in an activity log CSV into display text */
export const translateActivityLogTypes = (csv: string, t: TFunction): string =>
  translateCsvValues(csv, Object.values(LocationActivityLogType), (type) =>
    t(`locationActivityPage.locationActivityTable.type.${type}`, {
      defaultValue: type,
    })
  );
